import graphql from "babel-plugin-relay/macro";

export const QUERY = graphql`
	query fileAlreadyExistsChecker_Query($fileName: String) {
		Admin {
			FileAlreadyExist {
				Files(fileName: $fileName) {
					fileAlreadyExist {
						name
					}
				}
			}
		}
	}
`;
